import OldWizardConnectedPayrollSection from 'src/components/DUP/molecules/OldWizardConnectedPayrollSection/OldWizardConnectedPayrollSection';
import { OldWizardDocumentUploadSection } from 'src/components/DUP/molecules/OldWizardDocumentUploadSection/OldWizardDocumentUploadSection';
import { useApplication } from 'src/context/ApplicationContext';
import { UnauthenticateSessionProofType } from 'src/types/api';

export const OldWizardProofOfIncome = (props: { proofType: UnauthenticateSessionProofType }) => {
  const { connectedPayrollEnabled } = useApplication();

  return connectedPayrollEnabled ? (
    <OldWizardConnectedPayrollSection {...props} />
  ) : (
    <OldWizardDocumentUploadSection {...props} />
  );
};

export default OldWizardProofOfIncome;
